import React from "react";
import "../../src/Entities/styleInicio.css";
import "../../src/Entities/style-splash.css";


export const Inicio = () => {

  const goTo = (page, windowOut) => {
    window.location.href = "#/Inicio/Main";
  };

  return (
    <>
      <div
        style={{
          backgroundImage: `url(Images/Flyer5.jpg?v=${new Date().getTime()})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100vw 100vh",
          height: "100%",
          width: "100%",
          position: "fixed",
          top: 0,
          overflow: "auto",
        }}
      >
        <div
          className="container-fluid"
          style={{
            margin: "auto",
            marginTop: "5%",
            width: "60%",
            marginLeft: "20%",
            padding: "10px",
            maxHeight: "100vh",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "35%",
              marginTop: "-50px",
              marginLeft: "-50px",
              width: "100px",
              height: "100px",
            }}
          >
            <button className="squishy squishy-classic" onClick={() => goTo()}>¡Inscribete aquí...!</button>
          </div>
        </div>
      </div>
    </>
  );
};
